import React, { useEffect, useState } from 'react';
import { Card, Table, Pagination, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer, { initialState } from './reducer';
import saga from './saga';
import _ from 'lodash';
import { listSubscription } from './action';
// import clientReducer, { initialState as clientInitialState } from 'containers/Client/reducer';
import clientSaga from 'pages/Client/saga';
import { SubscriptionTableConfig } from './SubscriptionTableConfig';

function SubscriptionReports() {
  useInjectReducer({ key: 'subs', reducer });
  useInjectSaga({ key: 'subs', saga });
  // useInjectReducer({ key: 'client', reducer: clientReducer });
  // useInjectSaga({ key: 'client', saga: clientSaga });
  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [searchedColumn, setSearchedColumn] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const subscriptionState = useSelector((state) => state.subs || initialState);
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  useEffect(() => {
    const columns = SubscriptionTableConfig(
      handleSearch,
      handleReset,
      authState.userResponsibilities,
    );
    setColumns(columns);
    dispatch(listSubscription({ page: 1, limit: 10 }));
  }, []);

  const resetPagination = () => setCurrentPage(1);

  const onPageChange = (page, pageSize) => {
    let filter = { page, limit: pageSize };
    setCurrentPage(page);
    if ((searchedColumn, searchText)) {
      filter = { ...filter, [searchedColumn]: searchText };
    }
    dispatch(listSubscription(filter));
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length <= 0) {
      message.error('Please select to search');
      return;
    }
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    dispatch(listSubscription({ page: 1, limit: 10, [dataIndex]: selectedKeys[0] }));
    resetPagination();
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText(null);
    setSearchedColumn(null);
    dispatch(listSubscription({ page: 1, limit: 10 }));
    resetPagination();
  };
  return (
    <>
      <Card title="Subscription Reports">
        <Table
          columns={columns}
          loading={subscriptionState.loading}
          bordered
          pagination={false}
          size={'small'}
          dataSource={subscriptionState.data}
          style={{ height: '70vh', overflow: 'scroll' }}
        />
        <Pagination
          style={{ marginTop: '10px' }}
          total={subscriptionState.totalCount}
          showTotal={(total) => `Total ${total} items`}
          defaultPageSize={10}
          current={currentPage}
          showLessItems={true}
          showSizeChanger={false}
          disabled={subscriptionState.loading}
          onChange={onPageChange}
        />
      </Card>
    </>
  );
}

export default SubscriptionReports;
